<header>
	<button
		*ngIf="showSideNavToggle$ | async"
		class="side-nav-button"
		mat-icon-button
		[attr.aria-label]="'dashboard_expand-sidebar' | translate"
		(click)="toggleSideNav.emit()">
		<mat-icon class="ficon-menu"></mat-icon>
	</button>
	<breadcrumbs></breadcrumbs>
	<div class="header-menu">
		<button mat-button [matMenuTriggerFor]="menu"
			class="user-menu"
			[attr.aria-label]="'menu-button_user' | translate"
			data-cy="user-navigation-dropdown"
			[ngClass]="{ 'show-dropdown': !isMasked() }">
			<span class="display-name">
				<span class="user-name" [ngClass]="{ 'is-masked': isMasked() }">{{ currentUser.fullname || currentUser.full_name }}</span>
				<span *ngIf="isMasked()" class="unmask-indicator"><mat-icon class="ficon-times-circle"></mat-icon></span>
			</span>
			<span class="display-icon">
				<mat-icon class="ficon-app-user" [ngClass]="{ 'icon-masked': isMasked() }"></mat-icon>
				<span *ngIf="isMasked()" class="unmask-indicator"><mat-icon class="ficon-times-circle"></mat-icon></span>
			</span>
		</button>
		<mat-menu #menu="matMenu">
			<button *ngIf="isMasked()"
				mat-menu-item class="account-item is-masked unmask"
				[attr.aria-label]="'header_exit-mask-view' | translate"
				(click)="unMask()">
				{{ 'header_exit-mask-view' | translate }}
				<mat-icon class="ficon-times-circle"></mat-icon>
			</button>
			<mat-divider *ngIf="isMasked()"></mat-divider>
			<button mat-menu-item translate *ngIf="showAccountSettings()" (click)="openAccountSettingsPage()" class="account-item new-settings" data-cy="new-account-settings">header_account-settings</button>
			<button mat-menu-item translate *ngIf="shouldShowAdminTools()" (click)="openAdminToolsPage()" class="account-item admin-tools-lnk">header_admin-tools</button>
			<mat-divider></mat-divider>
			<a mat-menu-item translate href="https://get.goreact.com/terms" target="_blank" class="terms-lnk">footer_terms</a>
			<a mat-menu-item translate href="https://get.goreact.com/privacy" target="_blank" class="privacy-lnk">footer_privacy</a>
			<a mat-menu-item translate [attr.href]="helpUrls.security" target="_blank" class="compliance-lnk">header_compliance</a>
			<a mat-menu-item translate [attr.href]="helpUrls.accessibility" target="_blank" class="accessibility-lnk">header_accessibility</a>

			<ng-container *ngIf="!isLTI">
				<mat-divider></mat-divider>
				<button mat-menu-item translate (click)="openMobileApp()" class="dl-pwa">header_mobile-app</button>
				<button mat-menu-item translate (click)="logout()" class="logout-btn" data-cy="logout">log-out</button>
			</ng-container>
		</mat-menu>
	</div>
	<div class="save-and-exit-button-container" *ngIf="shouldShowSaveAndExitButton()">
		<a href="{{getLaunchPresentationUrl()}}" data-cy="save-and-exit" class="primary-btn" translate [attr.aria-label]="'save_and_exit' | translate">save_and_exit</a>
	</div>
</header>
